import { Link } from "react-router-dom";

export default function DefaultButton({
  route,
  children,
  onClick,
  useHref = false,
  type = "button",
  ...props
}) {
  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    if (route && useHref) {
      window.location.href = route; // Forces a full page reload
    }
  };

  const { className, ...otherProps } = props;
  
  const button = (
    <button
      type={type}
      className={`btn w-100 rounded-pill border-secondary btn-lg fw-bold ${className || ''}`}
      style={{ backgroundColor: className?.includes('btn-primary') ? undefined : "transparent" }}
      onClick={handleClick}
      {...otherProps}
    >
      {children}
    </button>
  );

  return route && !useHref ? <Link to={route}>{button}</Link> : button;
}
